import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Box } from '@mui/material';
import { Shops } from './';
import { ShopId } from '@core/store/slices/apiSlice.ts';

interface OverviewProps {
    shopIds: ShopId[];
    onLoading?: () => void;
    onLoaded?: () => void;
}

export interface OverviewRef {
    load: () => void;
}

const Overview = forwardRef<OverviewRef, OverviewProps>(({ shopIds, onLoading, onLoaded }, ref) => {
    const shopsRef = useRef<{ load: () => Promise<void> }>(null);

    useImperativeHandle(ref, () => ({
        load: async () => {
            await shopsRef.current?.load();
        }
    }));

    return (
        <Box sx={{ py: 3 }}>
            <Shops ref={shopsRef} shopIds={shopIds} selectable={false} onLoading={onLoading} onLoaded={onLoaded} />
        </Box>
    );
});

Overview.displayName = 'Overview';

export default Overview;
